// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { CreditBalance, CreditBucket, CreditCheckoutResponse, CreditsDay, CreditsSummary, CreditsUsage, FeatureDelta, ListRatesResponse, ModelDelta, Pack, PersonCredits, PersonDayCredits, ProjectCredits, RateInfo, Reconciliation, TokenTotals } from "../credits/dto.generated";
export const addTagTypes = ["credits"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiCreditRates: build.query<
        GetApiCreditRatesApiResponse,
        GetApiCreditRatesApiArg
      >({
        query: () => ({ url: `/api/credit-rates` }),
        providesTags: ["credits"],
      }),
      postApiCreditRates: build.mutation<
        PostApiCreditRatesApiResponse,
        PostApiCreditRatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/credit-rates`,
          method: "POST",
          body: queryArg.creditsCreateRateRequest,
        }),
        invalidatesTags: ["credits"],
      }),
      getApiWorkspacesByIdCredits: build.query<
        GetApiWorkspacesByIdCreditsApiResponse,
        GetApiWorkspacesByIdCreditsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/credits`,
        }),
        providesTags: ["credits"],
      }),
      postApiWorkspacesByIdCreditsCheckout: build.mutation<
        PostApiWorkspacesByIdCreditsCheckoutApiResponse,
        PostApiWorkspacesByIdCreditsCheckoutApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/credits/checkout`,
          method: "POST",
          body: queryArg.creditsCreditCheckoutRequest,
        }),
        invalidatesTags: ["credits"],
      }),
      postApiWorkspacesByIdCreditsGrants: build.mutation<
        PostApiWorkspacesByIdCreditsGrantsApiResponse,
        PostApiWorkspacesByIdCreditsGrantsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/credits/grants`,
          method: "POST",
          body: queryArg.creditsGrantCreditsRequest,
        }),
        invalidatesTags: ["credits"],
      }),
      getApiWorkspacesByIdCreditsReconcile: build.query<
        GetApiWorkspacesByIdCreditsReconcileApiResponse,
        GetApiWorkspacesByIdCreditsReconcileApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/credits/reconcile`,
          params: {
            from: queryArg["from"],
            to: queryArg.to,
          },
        }),
        providesTags: ["credits"],
      }),
      getApiWorkspacesByIdCreditsSummary: build.query<
        GetApiWorkspacesByIdCreditsSummaryApiResponse,
        GetApiWorkspacesByIdCreditsSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/credits/summary`,
        }),
        providesTags: ["credits"],
      }),
      getApiWorkspacesByIdCreditsUsage: build.query<
        GetApiWorkspacesByIdCreditsUsageApiResponse,
        GetApiWorkspacesByIdCreditsUsageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/credits/usage`,
          params: {
            from: queryArg["from"],
            to: queryArg.to,
          },
        }),
        providesTags: ["credits"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as creditsApi };
export type GetApiCreditRatesApiResponse =
  /** status 200 OK */ { data: CreditsListRatesResponse };
export type GetApiCreditRatesApiArg = void;
export type PostApiCreditRatesApiResponse =
  /** status 201 Created */ { data: CreditsRateInfo };
export type PostApiCreditRatesApiArg = {
  /** Rate row */
  creditsCreateRateRequest: CreditsCreateRateRequest;
};
export type GetApiWorkspacesByIdCreditsApiResponse =
  /** status 200 OK */ { data: CreditsCreditBalance };
export type GetApiWorkspacesByIdCreditsApiArg = {
  /** Workspace ID */
  id: string;
};
export type PostApiWorkspacesByIdCreditsCheckoutApiResponse =
  /** status 200 OK */ { data: CreditsCreditCheckoutResponse };
export type PostApiWorkspacesByIdCreditsCheckoutApiArg = {
  /** Workspace ID */
  id: string;
  /** The pack the buyer was shown */
  creditsCreditCheckoutRequest: CreditsCreditCheckoutRequest;
};
export type PostApiWorkspacesByIdCreditsGrantsApiResponse =
  /** status 201 Created */ { data: CreditsCreditBalance };
export type PostApiWorkspacesByIdCreditsGrantsApiArg = {
  /** Workspace ID */
  id: string;
  /** Grant request */
  creditsGrantCreditsRequest: CreditsGrantCreditsRequest;
};
export type GetApiWorkspacesByIdCreditsReconcileApiResponse =
  /** status 200 OK */ { data: CreditsReconciliation };
export type GetApiWorkspacesByIdCreditsReconcileApiArg = {
  /** Workspace ID */
  id: string;
  /** Window start, RFC3339. Defaults to 30 days ago. */
  from?: string;
  /** Window end, RFC3339, exclusive. Defaults to now. */
  to?: string;
};
export type GetApiWorkspacesByIdCreditsSummaryApiResponse =
  /** status 200 OK */ { data: CreditsCreditsSummary };
export type GetApiWorkspacesByIdCreditsSummaryApiArg = {
  /** Workspace ID */
  id: string;
};
export type GetApiWorkspacesByIdCreditsUsageApiResponse =
  /** status 200 OK */ { data: CreditsCreditsUsage };
export type GetApiWorkspacesByIdCreditsUsageApiArg = {
  /** Workspace ID */
  id: string;
  /** Window start, RFC3339. Defaults to 30 days ago; the window may not exceed 366 days. */
  from?: string;
  /** Window end, RFC3339, exclusive. Defaults to now. */
  to?: string;
};
export type CreditsRateInfo = RateInfo;
export type CreditsListRatesResponse = ListRatesResponse;
export type CreditsCreateRateRequest = {
  credits_per_million: number;
  effective_from?: string;
  model_id: string;
  provider: string;
  source: string;
  token_kind: "input" | "output" | "cache_read" | "cache_creation";
};
export type CreditsCreditBucket = CreditBucket;
export type CreditsCreditBalance = CreditBalance;
export type CreditsCreditCheckoutResponse = CreditCheckoutResponse;
export type CreditsCreditCheckoutRequest = {
  pack_id?: string;
};
export type CreditsGrantCreditsRequest = {
  amount: number;
  expires_at?: string;
  idempotency_key: string;
  note?: string;
  reference?: string;
  source: "plan" | "purchase" | "trial" | "support";
};
export type CreditsFeatureDelta = FeatureDelta;
export type CreditsModelDelta = ModelDelta;
export type CreditsReconciliation = Reconciliation;
export type CreditsPack = Pack;
export type CreditsCreditsSummary = CreditsSummary;
export type CreditsCreditsDay = CreditsDay;
export type CreditsPersonCredits = PersonCredits;
export type CreditsPersonDayCredits = PersonDayCredits;
export type CreditsProjectCredits = ProjectCredits;
export type CreditsTokenTotals = TokenTotals;
export type CreditsCreditsUsage = CreditsUsage;
export const {
  useGetApiCreditRatesQuery,
  useLazyGetApiCreditRatesQuery,
  usePostApiCreditRatesMutation,
  useGetApiWorkspacesByIdCreditsQuery,
  useLazyGetApiWorkspacesByIdCreditsQuery,
  usePostApiWorkspacesByIdCreditsCheckoutMutation,
  usePostApiWorkspacesByIdCreditsGrantsMutation,
  useGetApiWorkspacesByIdCreditsReconcileQuery,
  useLazyGetApiWorkspacesByIdCreditsReconcileQuery,
  useGetApiWorkspacesByIdCreditsSummaryQuery,
  useLazyGetApiWorkspacesByIdCreditsSummaryQuery,
  useGetApiWorkspacesByIdCreditsUsageQuery,
  useLazyGetApiWorkspacesByIdCreditsUsageQuery,
} = injectedRtkApi;
